import { SET_NOTIFICATION_DATA } from '../Constant/ActionConstant';

export const setNotificationData = (data) => ({
    type: SET_NOTIFICATION_DATA,
    payload: data
});
